module.exports = __webpack_public_path__ + "static/MR_APR19_WC_600x600px-3474c9dbe209d9c9f47947d84d2f6757.jpg";